import Vue from 'vue';
export default Vue.extend({
    name: 'leverageItemFolder',
    props: {
        item: {
            type: Object,
            required: true
        },
        folderMenuInstanceID: {
            required: true
        },
        folderIDToRename: {
            required: true
        }
    },
    data: () => ({
        newFolderName: '',
        folderNameEdit: false
    }),
    watch: {
        folderIDToRename(v) {
            const vm = this;
            if (vm.item.id === v)
                vm.folderNameEdit = true;
        }
    },
    methods: {
        handleCancelFolderNameEdit() {
            this.newFolderName = '';
            this.folderNameEdit = false;
        },
        handleApplyFolderNameEdit(name, id) {
            if (name)
                this.$emit('renameFolder', { name, id });
            this.newFolderName = '';
            this.folderNameEdit = false;
        },
        handleFieldInput(event) {
            if (event.keyCode !== 46 && event.keyCode !== 8) {
                if (isNaN(+event.key)) {
                    event.preventDefault();
                }
            }
        }
    }
});
